var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptSecretWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#252A41",
    d: "M18.6 9.01h-.04v-.67a7.56 7.56 0 00-15.12 0V9H3.4c-.71 0-1.29.58-1.29 1.29v9.63c0 .71.58 1.29 1.29 1.29h15.2c.71 0 1.29-.58 1.29-1.29V10.3c0-.72-.58-1.29-1.29-1.29zm-6.94 9.55h-1.33v-6.79h1.33v6.79zm5.39-9.55H4.95v-.67C4.95 5 7.66 2.29 11 2.29s6.05 2.72 6.05 6.05v.67z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptSecretWhite);
export default __webpack_public_path__ + "static/media/recrypt_secret_white.766cafee.svg";
export { ForwardRef as ReactComponent };